import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {
  getAllDeposits,
  GetAllPaymentsParams,
  getAllPayouts,
  getAllTransactions,
  GetAllTransactionsParams,
} from '../api';
import {
  QUERY__ALL_DEPOSITS,
  QUERY__ALL_PAYOUTS,
  QUERY__ALL_TRANSACTIONS,
} from '../queryKeys';
import {Transaction} from '../types';

export const useGetAllTransactions = <
  SelectedData = GetListOutput<Transaction>,
>(
  params: GetAllTransactionsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__ALL_TRANSACTIONS, params],
    queryFn: () => getAllTransactions(params),
    ...options,
  });
};

export const useGetAllDeposits = <SelectedData = GetListOutput<Transaction>>(
  params: GetAllPaymentsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__ALL_DEPOSITS, params],
    queryFn: () => getAllDeposits(params),
    ...options,
  });
};

export const useGetAllPayouts = <SelectedData = GetListOutput<Transaction>>(
  params: GetAllPaymentsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__ALL_PAYOUTS, params],
    queryFn: () => getAllPayouts(params),
    ...options,
  });
};
